import { NgModule } from '@angular/core';

import { VbUiToolbarComponent } from './VbUiToolbar.Component';

const components = [
	VbUiToolbarComponent
];

@NgModule({
	declarations: components,
	exports: components
})
export class VbUiToolbarModule {}
